
import React, { useState, useEffect } from 'react';

interface TypewriterEffectProps {
  phrases: string[];
  typingSpeed?: number;
  deletingSpeed?: number;
  pauseTime?: number;
}

const TypewriterEffect: React.FC<TypewriterEffectProps> = ({
  phrases,
  typingSpeed = 100, // Sped up from 200 to 100
  deletingSpeed = 100, // Slowed down from 75 to 100
  pauseTime = 2000, // Increased from 1500 to 2000 (longer pause)
}) => {
  const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(true);
  
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    const currentPhrase = phrases[currentIndex];
    
    if (isTyping) {
      if (currentText === currentPhrase) {
        // Finished typing the current phrase
        setIsTyping(false);
        timeout = setTimeout(() => {
          setIsTyping(false);
        }, pauseTime);
      } else {
        // Continue typing
        timeout = setTimeout(() => {
          setCurrentText(currentPhrase.substring(0, currentText.length + 1));
        }, typingSpeed);
      }
    } else {
      if (currentText === '') {
        // Move to next phrase
        setIsTyping(true);
        setCurrentIndex((currentIndex + 1) % phrases.length);
      } else {
        // Continue deleting
        timeout = setTimeout(() => {
          setCurrentText(currentText.substring(0, currentText.length - 1));
        }, deletingSpeed);
      }
    }
    
    return () => clearTimeout(timeout);
  }, [currentText, currentIndex, isTyping, phrases, typingSpeed, deletingSpeed, pauseTime]);
  
  return (
    <span className="text-[#8932c8] font-semibold">
      {currentText}
      <span className="animate-pulse">|</span>
    </span>
  );
};

export default TypewriterEffect;
